/**
 * FlatCalc Constants
 * All configuration values for the flat roofing estimator
 */

export const TABS = [
  { id: 'spec', label: 'Spec' },
  { id: 'areas', label: 'Areas' },
  { id: 'materials', label: 'Materials' },
  { id: 'labour', label: 'Labour' },
  { id: 'summary', label: 'Summary' }
];

export const MEMBRANE_TYPES = [
  { id: 'single_ply', label: 'Single Ply' },
  { id: 'rbm', label: 'RBM (Bituminous)' },
  { id: 'liquid', label: 'Liquid Applied' }
];

export const BUILD_UP_TYPES = [
  { id: 'warm_roof', label: 'Warm Roof', requiresVcl: true },
  { id: 'cold_roof', label: 'Cold Roof', requiresVcl: false },
  { id: 'inverted', label: 'Inverted Roof', requiresVcl: false },
  { id: 'overlay', label: 'Overlay', requiresVcl: false, canUseExistingAsVcl: true }
];

export const MEMBRANE_FIXING_METHODS = [
  { id: 'adhered', label: 'Fully Adhered' },
  { id: 'mech_fix', label: 'Mechanically Fixed' }
];

export const INSULATION_FIXING_METHODS = [
  { id: 'adhered', label: 'Adhered' },
  { id: 'mech_fix', label: 'Mechanically Fixed' }
];

export const GIRTH_BANDS = [
  { id: 'up_to_300', label: 'Up to 300mm', max: 300, rate: 12 },
  { id: '301_450', label: '301-450mm', max: 450, rate: 15 },
  { id: '451_600', label: '451-600mm', max: 600, rate: 18 },
  { id: '601_900', label: '601-900mm', max: 900, rate: 25 },
  { id: '901_1200', label: '901-1200mm', max: 1200, rate: 32 },
  { id: 'over_1200', label: 'Over 1200mm', max: 9999, rate: 40 }
];

export const EDGE_DETAIL_TYPES = [
  { id: 'edge_trim', label: 'Edge Trim', hasHeight: false, hasWidth: false },
  { id: 'wall_upstand', label: 'Wall Upstand (no termination)', hasHeight: true, hasWidth: false },
  { id: 'wall_upstand_term', label: 'Wall Upstand (with termination bar)', hasHeight: true, hasWidth: false },
  { id: 'parapet_no_trim', label: 'Parapet (no trim)', hasHeight: true, hasWidth: true },
  { id: 'parapet_1_trim', label: 'Parapet (1 trim)', hasHeight: true, hasWidth: true },
  { id: 'parapet_2_trim', label: 'Parapet (2 trims)', hasHeight: true, hasWidth: true }
];

export const OVERHANG_OPTIONS = [
  { id: 'both', label: 'Both Sides' },
  { id: 'single', label: 'Single Side' },
  { id: 'none', label: 'None' }
];

export const DEFAULT_LABOUR_RATES = {
  membrane_mech: 7.00,
  membrane_adhered: 8.50,
  vcl: 3.00,
  insulation_single: 4.00,
  insulation_double: 6.00,
  outlet: 45.00,
  penetration_small: 35.00,
  penetration_large: 55.00,
  rooflight: 85.00
};

export const DEFAULT_WASTAGE = {
  membrane: 10,
  vcl: 10,
  insulation: 5,
  fixings: 15,
  adhesive: 10
};

export const DEFAULT_ROLL_SPECS = {
  rollWidth: 2000,
  lapWidth: 100,
  rollLength: 15,
  overhang: 100,
  overhangSides: 'both'
};

export const DEFAULT_SPEC = {
  manufacturerId: null,
  membraneType: '',
  buildUp: '',
  deckMembraneId: null,
  flashingMembraneId: null,
  detailMembraneId: null,
  membraneFixingMethod: '',
  deckUnderlayId: null,
  deckCapId: null,
  flashingUnderlayId: null,
  flashingCapId: null,
  flashingSameAsDeck: true,
  detailUnderlayId: null,
  detailCapId: null,
  detailSameAsDeck: true,
  deckAdhesiveId: null,
  detailAdhesiveId: null,
  useDetailAsDeckAdhesive: false,
  useExistingAsVcl: false,
  vclId: null,
  vclPrimerId: null,
  deckPrimerId: null,
  insulationId: null,
  insulationThickness: 0,
  insulationLayers: 1,
  insulationFixingMethod: '',
  insulationAdhesiveId: null,
  insulationBondingArea: 0,
  fixingsPerBoard: 4
};

export const DEFAULT_AREAS = {
  areas: [],
  upstands: [],
  details: {
    outlets: 0,
    penetrationsSmall: 0,
    penetrationsLarge: 0,
    rooflights: 0,
    internalAngles: 0,
    externalAngles: 0
  }
};

export const DEFAULT_SUMMARY = {
  overheadPercent: 5,
  profitPercent: 15,
  vatPercent: 20
};

export const DEFAULT_RUN_CALC_DATA = {
  overhang: 100,
  overhangSides: 'both',
  invertedAreas: {},
  overrides: {},
  lapOverrides: {}
};
